import { captureMessage } from '@sentry/react';

export const populatePayloadFromSearchParams = <T>(
  payload: Partial<T>,
  keys: Array<keyof T> | { [K in keyof T]?: string },
  decodeSearchParam?: (value: string) => string,
) => {
  const searchParams = new URLSearchParams(document.location.search);
  const hasOtherSearchParams =
    Array.from(searchParams.values()).filter(Boolean).length > 0;

  const searchParamsToPopulate =
    !hasOtherSearchParams && decodeSearchParam
      ? new URLSearchParams(decodeSearchParam(document.location.search))
      : searchParams;

  const processSearchParam = (payloadKey: keyof T, searchParamKey: string) => {
    const value = searchParamsToPopulate.get(searchParamKey);
    if (value) {
      try {
        payload[payloadKey] = JSON.parse(value || '');
      } catch (e) {
        if (typeof value === 'string' && value !== 'undefined') {
          payload[payloadKey] = value as any;
        }

        captureMessage(
          `Failed to parse search param for the key(${String(
            payloadKey,
          )}). value= ${value}`,
          'info',
        );
      }
    }
  };

  if (Array.isArray(keys)) {
    keys.forEach((key) => {
      processSearchParam(key, String(key));
    });
  } else {
    Object.entries(keys).forEach(([payloadKey, searchParamKey]) => {
      processSearchParam(payloadKey as keyof T, searchParamKey as string);
    });
  }
};
